module.exports = __webpack_public_path__ + "img/zxfw1.3b71b184.png";